import {
  formatJsonImgUrl,
  formatOldJson,
  updateDefaultValues,
  updateScenesAndHotspots,
  updateMenuItemsWithScene,
  updateItemId,
  updateFeatureMedia,
  checkEnableBranding,
} from './jsonHelper';
import configs from '../configs';
import { combineTour } from './tourHelper';
import { convertObjectKeys } from './urlHelper';
import {
  forwardScenes,
  mapfloorplanCoors,
} from 'assets/override-json/override';

export const loadJson = async (url) => {
  try {
    const response = await fetch(url + '?v=' + new Date().getTime());
    return await response.json();
  } catch (error) {
    window.logMessage('load.json.error:', error);
    return null;
  }
};

export const ensureData = (data) => {
  updateFeatureMedia(data);
  updateScenesAndHotspots(data);
  updateMenuItemsWithScene(data);
  updateItemId(data);
  updateDefaultValues(data);
  return data;
};

export const loadFromUrl = async (jsonUrl) => {
  const json = await loadJson(jsonUrl);
  if (json) {
    const newData = convertObjectKeys(json);
    const data = formatOldJson(formatJsonImgUrl(jsonUrl, newData));
    return ensureData(data);
  }
  return null;
};

export const loadTourDetail = async (tourId) => {
  const response = await fetch(`${configs.apiUrl}Tours/${tourId}/detail`);
  const data = await response.json();
  return data.data;
};

export const loadTourSubscription = async (jsonUrl) => {
  const response = await fetch(jsonUrl);
  if (response) return response.json();
  return null;
};

export const loadTourJsons = async (tourId) => {
  try {
    const reqBody = {
      tours: [tourId],
    };
    if (configs.viewMode) {
      reqBody.isPublished = true;
    }
    const response = await fetch(`${configs.apiUrl}Tours/json`, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(reqBody),
    });
    const { data } = await response.json();
    if (data && data.length) {
      return data;
    }
  } catch (error) {
    window.logMessage('loadTourJsons.error', error);
  }
  return [];
};

export const loadPreviewJson = async (tourId) => {
  const data = await loadTourJsons(tourId);
  if (data && data.length) {
    return data.pop();
  }
  return null;
};

export const loadPublishedJson = async (tourId) => {
  const data = await loadTourJsons(tourId);
  if (data && data.length) {
    return data.find((d) => d.isPublished) || null;
  }
  return null;
};

var parsePreloadJsonScript = (jsonStr) => {
  const jsonStrFormatted = jsonStr
    .replace(/__OPEN_TAG__/g, '<')
    .replace(/__CLOSE_TAG__/g, '>');
  return JSON.parse(jsonStrFormatted);
};

function applyOverride(baseJson, overrideData) {
  const newJson = baseJson;

  overrideData.forEach((override) => {
    const { sceneId, hotspots } = override;

    const scene = newJson.scenes.find((scene) => scene._id === sceneId);

    if (scene) {
      hotspots.forEach(({ hotspotId, overrideOrientation }) => {
        const hotspot = scene.hotspots.find(
          (hotspot) => hotspot.baseId === hotspotId
        );
        if (hotspot) {
          hotspot.overrideOrientation = overrideOrientation;
        }
      });
    }
  });
}

function overrideMapFloorPlan(json, mapfloorplanCoors) {
  // Tạo bản sao của media để tránh thay đổi trực tiếp mảng gốc
  const updatedMedia = json.media;

  mapfloorplanCoors.forEach(({ mapId, objects }) => {
    // Tìm mapFloorPlan trong media dựa trên mapId
    const mediaItem = updatedMedia.find((item) => item._id === mapId);
    if (mediaItem && mediaItem.mapFloorPlan) {
      // Tìm objects trong mapFloorPlan để thực hiện override
      mediaItem.mapFloorPlan.forEach((floorPlan) => {
        floorPlan.objects.forEach((obj) => {
          const overrideObj = objects.find((o) => o.id === obj.id);
          if (overrideObj) {
            // Override coordinates
            obj.coordinates = overrideObj.coordinates;
          }
        });
      });
    }
  });

  return updatedMedia;
}

export const loadTourJson = async (tourAccessCode) => {
  const data = {
    tour: null,
    json: null,
  };

  const preloadEl = document.getElementById('vizion-data');

  if (preloadEl) {
    data.json = ensureData(parsePreloadJsonScript(preloadEl.textContent));
    data.tour = combineTour(data.json.tour, data.json);
    data.tour = checkEnableBranding(data.tour);
    window.data = data;

    return Promise.resolve(data);
  }

  try {
    // const tour = await loadTourDetail(tourAccessCode);
    // if (!tour?.id) return data;
    // if (!tour.active) return { tour };

    // const requestFunction = configs.viewMode
    //   ? loadPublishedJson
    //   : loadPreviewJson;
    // const jsonRecord = await requestFunction(tour.id);

    // window.logMessage('jsonRecord', jsonRecord);

    const json = await loadFromUrl('/assets/json/project.json');

    const tour = {};
    tour.subscriptionPlan = await loadTourSubscription(
      '/assets/json/tour-subscription.json'
    );

    if (json) {
      const json = await loadFromUrl('/assets/json/project.json');

      applyOverride(json, forwardScenes);
      overrideMapFloorPlan(json, mapfloorplanCoors);

      if (json) {
        json.tour.active = true;
        data.tour = combineTour(json.tour, json);
        data.tour = checkEnableBranding(data.tour, tour.subscriptionPlan);
        data.tour.subscriptionPlan = tour.subscriptionPlan;
        data.json = json;
      }
    }
  } catch (error) {
    window.logMessage('loadTourJson.error', error);
  }
  window.data = data;
  window.logMessage('window.data', data);
  return data;
};
